import type { PartnerPoiCategory, PoiCategory } from '$lib/components/pois/types';
import * as m from '$paraglide/messages';

const poiCategoryLabel: Record<Exclude<PoiCategory, PartnerPoiCategory>, () => string> = {
	RESTAURANT: m.poi_categories__restaurant,
	ACCOMMODATION: m.poi_categories__accommodation,
	TOURISM: m.poi_categories__tourism,
	SERVICE_GAS_STATION: m.poi_categories__gas_station,
	EV_SERVICE: m.poi_categories__ev_service,
	PARKING: m.poi_categories__parking,
	REST_STOP: m.poi_categories__rest_stop,
};
export function poiCategories(category: Exclude<PoiCategory, PartnerPoiCategory>): string {
	return poiCategoryLabel[category]();
}
